(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["low-stock"] && !Shopify.designMode) return;
  try {
    class LowStockNotice extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section, dialog');
      this.handleUpdate = this.handleUpdate.bind(this);
      if (this.scope) this.scope.addEventListener('variant:update', this.handleUpdate);
    }

    disconnectedCallback() {
      if (this.scope) this.scope.removeEventListener('variant:update', this.handleUpdate);
    }

    handleUpdate(event) {
      const data = event.detail && event.detail.data;
      if (!data || !data.html) return;

      if (data.newProduct) {
        this.dataset.productId = data.newProduct.id;
      } else if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }

      const next = data.html.querySelector('low-stock-notice');
      if (next) this.innerHTML = next.innerHTML;
    }
  }

  if (!customElements.get('low-stock-notice')) {
    customElements.define('low-stock-notice', LowStockNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
